var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaxviewIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    viewBox: "0 0 56 56",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 17.462 17.872 20h2.256z",
    fill: "#284c69",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 51h32.01A12.99 12.99 0 0 1 38 26.05V11h-7a4 4 0 0 1-4-4V0H2a2.006 2.006 0 0 0-2 2v47a2.006 2.006 0 0 0 2 2zm24.17-35.45a1 1 0 1 1 1.66-1.1L30 17.7l2.17-3.25a.979.979 0 0 1 1.38-.28.99.99 0 0 1 .28 1.38L31.2 19.5l2.63 3.95a.99.99 0 0 1-.28 1.38.939.939 0 0 1-.55.17 1 1 0 0 1-.83-.45L30 21.3l-2.17 3.25A1 1 0 0 1 27 25a.939.939 0 0 1-.55-.17.99.99 0 0 1-.28-1.38l2.63-3.95zm-6.26-.96 2.67 6.01c.01.01.01.01.01.03l1.32 2.96a.993.993 0 0 1-.5 1.32.992.992 0 0 1-1.32-.5L21.02 22h-4.04l-1.07 2.41a.992.992 0 0 1-1.32.5.993.993 0 0 1-.5-1.32l1.32-2.96c0-.02 0-.02.01-.03l2.67-6.01a1 1 0 0 1 1.82 0zM4 3h13a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 5h6a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h8a1 1 0 0 1 0 2H9v8a1 1 0 0 1-2 0v-8H4a1 1 0 0 1 0-2zm0 14h22.52a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 5h19.8a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 5h7a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z",
    fill: "#284c69",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 28c-6.075 0-11 4.925-11 11s4.925 11 11 11 11-4.925 11-11c-.004-6.074-4.926-10.996-11-11zm0 19a8 8 0 1 1 8-8 8.011 8.011 0 0 1-8 8zM49.183 47.057a13.115 13.115 0 0 1-2.126 2.126l6.38 6.38c.597.564 1.53.564 2.126 0 .58-.59.58-1.538 0-2.129zM36.589 9 29 1.414V7a2 2 0 0 0 2 2z",
    fill: "#284c69",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxviewIcon);
export default __webpack_public_path__ + "static/media/taxview_icon.976ec9dbbf66542bcd062ca096bc13c2.svg";
export { ForwardRef as ReactComponent };